module.exports = __webpack_public_path__ + "static/full-stack-project-42-2-24e9549cd477c390006f3254d57ca5bc.png";